import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles<{ justifyIcon: 'flex-start' | 'flex-end' | 'center' }>()((theme, {
    justifyIcon,
}) => {
    return {
        iconWrapper: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: justifyIcon,
        },
        icon: {
            color: theme.palette.primary[500],
            width: '22px !important',
            height: '22px !important',
        },

    }
})

export default useStyles
